export default "__VITE_ASSET__R7IjaTB7__"